import { render, staticRenderFns } from "./PermisoFarmaciaAnulacion.vue?vue&type=template&id=123ca2c0&scoped=true"
import script from "./PermisoFarmaciaAnulacion.vue?vue&type=script&lang=js"
export * from "./PermisoFarmaciaAnulacion.vue?vue&type=script&lang=js"
import style0 from "./PermisoFarmaciaAnulacion.vue?vue&type=style&index=0&id=123ca2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ca2c0",
  null
  
)

export default component.exports